import React from 'react'
import ReactDOM from 'react-dom/client'
import { Amplify } from 'aws-amplify'
import LogRocket from 'logrocket'
import { Authenticator } from '@aws-amplify/ui-react'
import './index.css'
import './global/css/fonts.css'
import BaseContainer from './base/components/base-container/BaseContainer'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
import { ToastNotificationContextProvider } from './global/context/toast-context/ToastNotificationContext'
import { IS_ENV_LOCAL } from './global/constants/env'

if (!IS_ENV_LOCAL) {
  LogRocket.init(process.env.REACT_APP_LOG_ROCKET_APP_ID || '')
}

Amplify.configure({
  Auth: {
    region: 'us-east-1',
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_CLIENT_ID,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    oauth: {
      domain: 'schedule-asaptire-app.auth.us-east-1.amazoncognito.com',
      scope: ['email', 'openid'],
      redirectSignIn: `${window.location.origin}/`,
      redirectSignOut: `${window.location.origin}/`,
      responseType: 'code',
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  // <React.StrictMode>
  <Authenticator.Provider>
    <BrowserRouter>
      <ToastNotificationContextProvider>
        <BaseContainer />
      </ToastNotificationContextProvider>
    </BrowserRouter>
  </Authenticator.Provider>,
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
